import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LegalChecksFormModel } from '@shared/models/forms/legal-check-form.model';

export function createLegalCheckForm(): FormGroup<LegalChecksFormModel> {
  return new FormGroup<LegalChecksFormModel>({
    isContactConsent: new FormControl<boolean | null>(false, [Validators.requiredTrue]),
    isGdprAccepted: new FormControl<boolean | null>(false, [Validators.requiredTrue])
  });
}
